//PAQUETERIAS
import { useEffect, useState, useMemo, useRef } from "react";
import { CustomDialog } from "react-st-modal";
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import NotificationSystem from 'react-notification-system';
//COMPONENTES
import SET_CONCEPT from "./tools/set_concept";
import { BREADCRUMBS } from "../../../main_components/pagination/breadcrumbs";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../../main_components/methods_v2/export";
import RENDER_ROW_ACTION_MENU_ITEMS from "./tools/render_row_action_menuItems";
import AlertResponse from "../../../main_components/alerts/alertResponse";
import TAX_CONCEPT from "./tax_concept";
import { update_null_identifiers } from "../../../main_components/methods_v2/auxiliar_funtion";

import { findInObjectDisplayRole } from "../../../Content/verify_role";
//ESTILOS
import "../../estilo.css";
import "./tableclientes.css";
import "../../modal.css";

//IMAGENES/ICONOS
import CREATE from "../../../imgComponents/create.png";
import { concepts_get } from "../../../services/invoices/concepts";

const CONSUL_CONCEPT_V2 = () => {
  const [data, setData] = useState([]);
  const [modalT, setmodalT] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const notificationSystemRef = useRef();
  const [total_rows, settotal_rows] = useState("");


  const handleSubmit = async () => {
    setIsLoading(true);
    setmodalT(true);
    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        setTimeout(async () => {
          try {
            const dt = await concepts_get();
            var ndt = update_null_identifiers(dt?.data, update_identifiers);
            setData(ndt);
            setmodalT(false);
            setIsLoading(false);
          } catch (err) {
            console.log("error", err);
            setData([]);
            setIsLoading(false);
            setmodalT(false);
          }
        }, 1000);
      } else { }
    } catch (err) {
      console.log(err);
    }
  };

  function alertas(msj, status) {

    if (status === true) {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={true}></AlertResponse>,
        level: 'success',
        position: 'br',
        autoDismiss: 10,
      });
    } else {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={false}></AlertResponse>,
        level: 'error',
        position: 'br',
        autoDismiss: 60,
      });
    }
  }

  useEffect(() => {
    handleSubmit();
  }, []);

  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };

  const columns = useMemo(
    () => [
      {
        id: "concept",
        header: "Concepto",
        accessorKey: "concept",
        size: 300,
      },
      {
        id: "descripcion",
        header: "Descripción",
        accessorKey: "descripcion",
        size: 300,
      },
      {
        id: "valor_unitario",
        header: "Valor Unitario",
        accessorKey: "valor_unitario",
      },
      {
        id: "clave_prod_serv",
        header: "Clave Producto Servicio",
        accessorKey: "clave_prod_serv",
      },
      {
        id: "clave_unidad",
        header: "Clave Unidad",
        accessorKey: "clave_unidad",
      },
      {
        id: "unidad",
        header: "Unidad",
        accessorKey: "unidad",
      },
      {
        id: "no_identificacion",
        header: "Número de Identificación",
        accessorKey: "no_identificacion",
      },
    ],
    []
  );


  const update_identifiers =
    [
      { concept: 'string' },
      { descripcion: 'string' },
      { valor_unitario: 'String' },
      { clave_prod_serv: 'string' },
      { clave_unidad: 'string' },
      { unidad: 'string' },
      { no_identificacion: 'string' }
    ];


  const [rec, setrec] = useState(false);

  return (
    <div >
      <NotificationSystem ref={notificationSystemRef} ></NotificationSystem>
      <BREADCRUMBS niveles={
        [
          { label: "CONSULTAR CONCEPTOS", path: null },
        ]
      }
        old_version={false}
        modul="CONSULTAR CONCEPTOS V1"
        path="/consult_concept"
        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>
      <div>
        <MODAL_TABLE
          open={true}
          message={""}
          modalGeneral={false}
          modalT={modalT}
        ></MODAL_TABLE>
      </div>
      <div className="new_table_v2">
        <MaterialReactTable
          columns={columns}
          data={data}
          enableGrouping
          enablePinning
          enableFacetedValues
          enableStickyHeader
          enableStickyFooter
          enableRowPinning
          enableColumnFilterModes
          enableRowActions={findInObjectDisplayRole(["IN:CO1", "IN:CO2", "IN:CO3"]) === "none" ? false : true}
          enableRowSelection
          getRowId={(row) => row?.id}
          onRowSelectionChange={setRowSelection}
          enableTooltips={false}
          localization={MRT_Localization_ES}
          state={{ rowSelection, isLoading: isLoading }}
          enableColumnResizing
          onStateChange={handleStateChange}
          enableColumnPinning
          enableColumnOrdering
          enableExpandAll={false}
          initialState={{ showGlobalFilter: true }}
          muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
          muiSkeletonProps={{ animation: 'pulse', height: 28 }}
          rowVirtualizerInstanceRef
          rowVirtualizerOptions={{ overscan: 5 }}
          columnVirtualizerOptions={{ overscan: 2 }}
          muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
          positionToolbarAlertBanner="bottom"
          paginationDisplayMode='pages'
          rowPinningDisplayMode='sticky'
          layoutMode="grid"
          muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important", } }}
          muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
          muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
          displayColumnDefOptions={{
            'mrt-row-pin': {
              Header: () => (
                <div>
                  <img
                    style={{ cursor: "pointer", display: findInObjectDisplayRole(["IN:CO2", "IN:CO3"]) }}
                    title="Crear Concepto"
                    src={CREATE}
                    className=""
                    onClick={async () => {
                      const result = await CustomDialog(
                        <SET_CONCEPT
                          setmodalT={setmodalT}
                          handleSubmit={handleSubmit}
                          alertas={alertas}
                          Concepto={""}
                          Clave_prod_serv={"01010101"}
                          Clave_unidad={"ACT"}
                          Descripcion={""}
                          No_identificacion={""}
                          Objeto_imp={"01"}
                          Peso_en_kg={"1"}
                          Valor_unitario={0}
                          Unidad={"ACTIVIDAD"}
                          method={"CREATE"}
                        ></SET_CONCEPT>,
                        {
                          className: "custom-modal-3",
                          title: "Seleccione la configuracion del concepto",
                          showCloseIcon: true,
                          isCanClose: false,
                        }
                      );
                    }}
                  ></img>
                </div>
              ),
              enableHiding: true,
            },
            'mrt-row-actions': {
              enableHiding: true,
            },
            'mrt-row-expand': {
              enableHiding: true,
            },
            'mrt-row-select': {
              enableHiding: true,
            }
          }}
          muiTableBodyRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                data.splice(
                  hoveredRow.index,
                  0,
                  data.splice(draggingRow.index, 1)[0],
                );
                setData([...data]);
              }
            },
          })}
          muiTableBodyRowProps={
            ({ row, table }) => {
              settotal_rows(table);
              const { density } = table.getState();
              return {
                sx: {
                  height: row.getIsPinned()
                    ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                    }px`
                    : undefined,
                },
              };
            }
          }
          renderDetailPanel={({ row }) => {
            return (
              <TAX_CONCEPT
                id={row?.original?.id}
                setmodalT={setmodalT}
                alertas={alertas}
                rec={rec}
                setrec={setrec}
              />
            )
          }}

          renderRowActionMenuItems={({ row, closeMenu }) =>
            [
              <RENDER_ROW_ACTION_MENU_ITEMS
                key="menu"
                closeMenu={closeMenu}
                setmodalT={setmodalT}
                row={row}
                handleSubmit={handleSubmit}
                alertas={alertas}
                setrec={setrec}
              />
            ]

          }

          renderToolbarInternalActions={({ table }) => (
            <RENDER_TOOLBAR_INTERNAL_ACTIONS
              table={table}
              file_name={"Consultar Conceptos"}
              update_identifiers={update_identifiers}
              settotal_rows={settotal_rows}
            />
          )
          }
        />

      </div>
    </div>
  );
};

export default CONSUL_CONCEPT_V2;
